import { defineComponent } from "vue";
import Avatar from "../../common/Avatar.vue.mjs";
import useUserInfo from "./useUserInfoHooks.mjs";
import "../../../directives/vTap.mjs";
import "../../../services/main.mjs";
import { roomService } from "../../../services/roomService.mjs";
import "../../../locales/index.mjs";
import "@tencentcloud/tuiroom-engine-js";
import "../../../utils/environment.mjs";
import "mitt";
import "../../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UserInfoH5",
  props: {
    userId: null,
    userName: null,
    avatarUrl: null
  },
  emits: ["log-out"],
  setup(__props) {
    const userInfoConfig = roomService.getComponentConfig("UserInfo");
    const { userInfoRef, showUserControl, t, handleUserControl } = useUserInfo();
    return { __sfc: true, userInfoConfig, userInfoRef, showUserControl, t, handleUserControl, Avatar };
  }
});
export {
  _sfc_main as default
};
